module.exports = __webpack_public_path__ + "static/media/aboutus.e2fee7ee.jpg";